module.exports = __webpack_public_path__ + "img/LogotipoValorLatino.1b3ba6d0.png";